import { useLocation, useMatch } from 'react-router-dom';
import { useFlag } from 'shared/settings/FeatureToggles';

export function useSubhaulLoad() {
  const isSubhauledEnabled = useFlag('ctms_edi_subhaul');
  const isPrimeCarrierSubhaulLoadEditPage = useMatch(
    '/vehicles/subhauled/:guid/edit',
  );
  const { pathname } = useLocation();
  const isSubhauled =
    isSubhauledEnabled && pathname.includes('/vehicles/subhauled/');

  return { isSubhauled, isPrimeCarrierSubhaulLoadEditPage };
}
